(() => {
  if (customElements.get('pinq-mobile-menu')) return;

  class PinqMobileMenu extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.drawer = this.closest('[data-drawer="hamburger"]');
      this.main = this.querySelector('[data-pinq-menu-main]');
      this.panels = Array.from(this.querySelectorAll('[data-pinq-menu-panel]'));
      this.openers = Array.from(this.querySelectorAll('[data-pinq-panel-open]'));
      this.activeOpener = null;

      this.openers.forEach((opener) => {
        opener.addEventListener('click', () => {
          opener.classList.add('is-pressed');
          window.setTimeout(() => {
            opener.classList.remove('is-pressed');
            this.openPanel(opener.dataset.pinqPanelOpen, opener);
          }, 120);
        });
      });

      this.querySelectorAll('[data-pinq-panel-back]').forEach((button) => {
        button.addEventListener('click', () => this.closePanel(true));
      });

      this.drawer?.addEventListener('theme:drawer:close', () => this.closePanel(false));
    }

    openPanel(panelId, opener) {
      const panel = this.querySelector(`#${CSS.escape(panelId)}`);
      if (!panel) return;

      this.closePanel(false);
      this.activeOpener = opener;
      this.classList.add('is-panel-open');
      this.main?.setAttribute('aria-hidden', 'true');
      opener.setAttribute('aria-expanded', 'true');
      panel.classList.add('is-active');
      panel.setAttribute('aria-hidden', 'false');
      panel.scrollTop = 0;

      window.setTimeout(() => panel.querySelector('[data-pinq-panel-back]')?.focus(), 360);
    }

    closePanel(restoreFocus) {
      this.classList.remove('is-panel-open');
      this.main?.setAttribute('aria-hidden', 'false');
      this.panels.forEach((panel) => {
        panel.classList.remove('is-active');
        panel.setAttribute('aria-hidden', 'true');
      });
      this.openers.forEach((opener) => opener.setAttribute('aria-expanded', 'false'));

      if (restoreFocus && this.activeOpener) this.activeOpener.focus();
      this.activeOpener = null;
    }
  }

  customElements.define('pinq-mobile-menu', PinqMobileMenu);
})();
